import React, { Component } from 'react';

class Dashboard extends Component {

  render() {
    return (<>

      {/* [ Main Content ] start */}
      <div className="pc-container">
        <div className="pc-content">
          {/* [ breadcrumb ] start */}
          <div className="page-header">
            <div className="page-block">
              <div className="row align-items-center">
                <div className="col-md-12">
                  <ul className="breadcrumb mb-0">
                    <li className="breadcrumb-item"><a href="#"><i className="ti ti-home-2" /></a></li>
                    <li className="breadcrumb-item" aria-current="page">Dashboard</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          {/* [ breadcrumb ] end */}
          {/* [ Main Content ] start */}
          <div className="row">

            <div className="col-xxl-3 col-md-4">
              <div className="card">
                <div className="card-body">
                  <div className="d-flex align-items-center">
                    <div className="flex-grow-1 me-3">
                      <p className="mb-1 fw-medium text-muted">Today Orders:(5)</p>
                      <h4 className="mb-1">৳980</h4>
                    </div>
                    <div className="flex-shrink-0">
                      <div className="avatar avatar-l bg-light-primary rounded-circle">
                        <i className="ph ph-book-bookmark f-28" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xxl-3 col-md-4">
              <div className="card">
                <div className="card-body">
                  <div className="d-flex align-items-center">
                    <div className="flex-grow-1 me-3">
                      <p className="mb-1 fw-medium text-muted">Courier Orders:(6)</p>
                      <h4 className="mb-1">৳1080</h4>
                    </div>
                    <div className="flex-shrink-0">
                      <div className="avatar avatar-l bg-light-success rounded-circle">
                        <i className="ph ph-rocket f-28" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xxl-3 col-md-4">
              <div className="card">
                <div className="card-body">
                  <div className="d-flex align-items-center">
                    <div className="flex-grow-1 me-3">
                      <p className="mb-1 fw-medium text-muted">Confirmed Orders:(3)</p>
                      <h4 className="mb-1">৳1080</h4>
                    </div>
                    <div className="flex-shrink-0">
                      <div className="avatar avatar-l bg-light-warning rounded-circle">
                        <i className="ph ph-credit-card f-28" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xxl-3 col-md-4">
              <div className="card">
                <div className="card-body">
                  <div className="d-flex align-items-center">
                    <div className="flex-grow-1 me-3">
                      <p className="mb-1 fw-medium text-muted">Pending Orders:(3)</p>
                      <h4 className="mb-1">৳1080</h4>
                    </div>
                    <div className="flex-shrink-0">
                      <div className="avatar avatar-l bg-light-warning rounded-circle">
                        <i className="ph ph-user-minus f-28" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-xxl-3 col-md-4">
              <div className="card">
                <div className="card-body">
                  <div className="d-flex align-items-center">
                    <div className="flex-grow-1 me-3">
                      <p className="mb-1 fw-medium text-muted">Hold Orders:(7)</p>
                      <h4 className="mb-1">৳1000</h4>
                    </div>
                    <div className="flex-shrink-0">
                      <div className="avatar avatar-l bg-light-danger rounded-circle">
                        <i className="ph ph-user-minus f-28" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-xxl-3 col-md-4">
              <div className="card">
                <div className="card-body">
                  <div className="d-flex align-items-center">
                    <div className="flex-grow-1 me-3">
                      <p className="mb-1 fw-medium text-muted">Cancelled Orders:(7)</p>
                      <h4 className="mb-1">৳1000</h4>
                    </div>
                    <div className="flex-shrink-0">
                      <div className="avatar avatar-l bg-light-danger rounded-circle">
                        <i className="ph ph-user-minus f-28" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <hr></hr>

            <div className="col-xxl-3 col-md-4">
              <div className="card">
                <div className="card-body">
                  <div className="d-flex align-items-center">
                    <div className="flex-grow-1 me-3">
                      <p className="mb-1 fw-medium text-muted">Registrations</p>
                      <h4 className="mb-1">980+</h4>
                    </div>
                    <div className="flex-shrink-0">
                      <div className="avatar avatar-l bg-light-primary rounded-circle">
                        <i className="ph ph-users f-24" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-xxl-3 col-md-4">
              <div className="card">
                <div className="card-body">
                  <div className="d-flex align-items-center">
                    <div className="flex-grow-1 me-3">
                      <p className="mb-1 fw-medium text-muted">Total Products</p>
                      <h4 className="mb-1">1,563</h4>
                    </div>
                    <div className="flex-shrink-0">
                      <div className="avatar avatar-l bg-light-success rounded-circle">
                        <i className="ph ph-bag f-28" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-xxl-3 col-md-4">
              <div className="card">
                <div className="card-body">
                  <div className="d-flex align-items-center">
                    <div className="flex-grow-1 me-3">
                      <p className="mb-1 fw-medium text-muted">Total Expenses</p>
                      <h4 className="mb-1">42.6%</h4>
                    </div>
                    <div className="flex-shrink-0">
                      <div className="avatar avatar-l bg-light-danger rounded-circle">
                        <i className="ph ph-address-book-tabs f-28" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <hr></hr>

            <div className="col-xxl-3 col-md-3">
              <div className="card">
                <div className="card-body">
                  <div className="d-flex align-items-center">
                    <div className="flex-grow-1 me-3">
                      <p className="mb-1 fw-medium text-muted">Registrations</p>
                      <h4 className="mb-1">980+</h4>
                    </div>
                    <div className="flex-shrink-0">
                      <div className="avatar avatar-l bg-light-primary rounded-circle">
                        <i className="ph ph-book-bookmark f-28" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xxl-3 col-md-3">
              <div className="card">
                <div className="card-body">
                  <div className="d-flex align-items-center">
                    <div className="flex-grow-1 me-3">
                      <p className="mb-1 fw-medium text-muted">Total Products</p>
                      <h4 className="mb-1">1,563</h4>
                    </div>
                    <div className="flex-shrink-0">
                      <div className="avatar avatar-l bg-light-success rounded-circle">
                        <i className="ph ph-rocket f-28" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xxl-3 col-md-3">
              <div className="card">
                <div className="card-body">
                  <div className="d-flex align-items-center">
                    <div className="flex-grow-1 me-3">
                      <p className="mb-1 fw-medium text-muted">Total Income (0 txns)</p>
                      <h4 className="mb-1">42.6%</h4>
                    </div>
                    <div className="flex-shrink-0">
                      <div className="avatar avatar-l bg-light-warning rounded-circle">
                        <i className="ph ph-credit-card f-28" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xxl-3 col-md-3">
              <div className="card">
                <div className="card-body">
                  <div className="d-flex align-items-center">
                    <div className="flex-grow-1 me-3">
                      <p className="mb-1 fw-medium text-muted">Total Expenses</p>
                      <h4 className="mb-1">42.6%</h4>
                    </div>
                    <div className="flex-shrink-0">
                      <div className="avatar avatar-l bg-light-danger rounded-circle">
                        <i className="ph ph-user-minus f-28" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>




            <div className="col-lg-7 col-md-12">
              <div className="card">
                <div className="card-body">
                  <div className="d-flex align-items-start justify-content-between">
                    <h5 className="mb-0">Revenue analytics</h5>
                    <select className="form-select rounded-3 form-select-sm w-auto">
                      <option>Today</option>
                      <option>Weekly</option>
                      <option selected>Monthly</option>
                    </select>
                  </div>
                  <div id="revenue-analytics-chart" />
                </div>
              </div>
            </div>

            <div className="col-lg-5 col-md-12">
              <div className="card">
                <div className="card-body">
                  <div className="d-flex align-items-start justify-content-between mb-3">
                    <h5 className="mb-0">Activity</h5>
                    <select className="form-select rounded-3 form-select-sm w-auto">
                      <option>Today</option>
                      <option>Weekly</option>
                      <option selected>Monthly</option>
                    </select>
                  </div>
                  <div id="activity-line-chart" />
                </div>
              </div>
            </div>
            <div className="col-lg-7 col-md-12">
              <div className="card table-card">
                <div className="card-header">
                  <div className="d-flex align-items-center justify-content-between">
                    <h5 className="mb-0">Latest Order List</h5>
                    <button className="btn btn-sm btn-link-primary">View All</button>
                  </div>
                </div>
                <div className="card-body pb-0">
                  <div className="table-responsive">
                    <table className="table table-hover mb-0">
                      <thead>
                        <tr>
                          <th>Name</th>
                          <th>Date</th>
                        </tr>
                      </thead>
                      <tbody>

                        <tr>
                          <td>
                            <div className="d-flex align-items-center">
                              <div className="flex-shrink-0">
                                <img src="assets/images/user/avatar-4.svg" alt="user image" className="img-radius wid-40 align-top m-r-15" />
                              </div>
                              <div className="flex-grow-1 ms-3">
                                <h6 className="mb-0">Airi Satou</h6>
                                <h6 className="mb-0">Airi Satou</h6>
                              </div>
                            </div>
                          </td>
                          <td>2025/07/12</td>
                        </tr>


                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-5 col-md-12">
              <div className="card">
                <div className="card-body">
                  <div className="d-flex align-items-start justify-content-between mb-3">
                    <h5 className="mb-0">Activity</h5>
                    <select className="form-select rounded-3 form-select-sm w-auto">
                      <option>Today</option>
                      <option>Weekly</option>
                      <option selected>Monthly</option>
                    </select>
                  </div>
                  <div className="card-body pb-0">
                    <div className="table-responsive">
                      <table className="table table-hover mb-0">
                        <thead>
                          <tr>
                            <th>Name</th>
                            <th>Date</th>
                          </tr>
                        </thead>
                        <tbody>

                          <tr>
                            <td>
                              <div className="d-flex align-items-center">
                                <div className="flex-shrink-0">
                                  <img src="assets/images/user/avatar-4.svg" alt="user image" className="img-radius wid-40 align-top m-r-15" />
                                </div>
                                <div className="flex-grow-1 ms-3">
                                  <h6 className="mb-0">Airi Satou</h6>
                                </div>
                              </div>
                            </td>
                            <td>22</td>
                          </tr>


                        </tbody>
                      </table>

                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* [ Main Content ] end */}
        </div>
      </div>
      {/* [ Main Content ] end */}

    </>);
  };
}

export default Dashboard;
